module.exports = __webpack_public_path__ + "static/media/draught1.43432101.webp";